import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'woValueOrElse', standalone: true })
export class ValueOrElsePipe implements PipeTransform {
  public transform<T, K>(value: T, orElse: K): NonNullable<T> | K {
    return value ?? orElse;
  }
}
